import { mapActions } from 'vuex'
import EventBus from '@/eventBus.js'
import CanvasBlocksUpdateMixin from '@/mixins/presentation/CanvasBlocksUpdateMixin'
import util from '@/util'
import eventCategories from '@/constant/eventCategories'
import { buildCanvasBlocksFromTemplate } from '../../utils/CanvasBlocksLayout'
import { removeObjectFromIndexedDB, setObjectToIndexedDB, Stores } from '@/utils/indexedDB/indexed.db'
import { copyBackgroundCacheToSlides } from '@/utils/indexedDB/image.cache.utils'

export default {
  mixins: [CanvasBlocksUpdateMixin],
  methods: {
    ...mapActions(['updateSlideActiveAction']),

    backupSlide(oldSlide, newSlide) {
      this.addActionToHistory({
        type: 'UpdateSlide',
        data: oldSlide,
        newData: newSlide,
        slideActiveId: this.slideActive.id,
      })
    },
    async restoreUpdateSlide(slide) {
      this.updateSlideActiveAction(slide)
      EventBus.$emit('eventHandleSetValueTransition')
      setObjectToIndexedDB(slide.id, Stores.contentSlideCanvasBlocksStore, {
        canvasBlocks: slide.canvasBlocks,
      })
      await this.callUpdateSlideApi({
        ...slide,
        backgroundImage: slide.backgroundImage && slide.backgroundImage.name,
        image: slide.image && slide.image.name,
      }, slide.id)
    },

    async applyTemplate(template) {
      if (this.$store.state.blockContentCache) {
        this.updateCanvasBlocks(this.dataCanvasBlocks, this.slideActive.id)
        this.$store.state.blockContentCache = null
      }
      this.oldSlide = {
        id: this.slideActive.id,
        textColour: this.slideActive.textColour,
        baseColour: this.slideActive.baseColour,
        visibility: this.slideActive.visibility,
        backgroundImage: this.slideActive.backgroundImage,
        image: this.slideActive.image,
        canvasBlocks: this.slideActive.canvasBlocks,
        accessCode: this.presentation.uniqueAccessCode,
        backgroundCache: this.slideActive.backgroundCache,
        cropperDataCache: this.slideActive.cropperDataCache,
        originBackgroundCache: this.slideActive.originBackgroundCache,
      }
      const newCanvasBlocks = buildCanvasBlocksFromTemplate(template.canvasBlocks, this.slideActive.id)
      this.newSlide = {
        textColour: template.textColour,
        baseColour: template.baseColour,
        visibility: template.visibility,
        backgroundImage: template.backgroundImage,
        image: null,
        canvasBlocks: newCanvasBlocks,
        accessCode: this.presentation.uniqueAccessCode,
        backgroundCache: template.backgroundCache || (template.backgroundImage ? template.backgroundImage.large : null),
        originBackgroundCache: template.backgroundImage ? template.backgroundImage.large : null,
        cropperDataCache: null,
      }

      this.updateSlideActiveAction(this.newSlide)
      setObjectToIndexedDB(this.slideActive.id, Stores.contentSlideCanvasBlocksStore, {
        canvasBlocks: newCanvasBlocks,
      })
      if (template.backgroundImage) {
        copyBackgroundCacheToSlides({
          backgroundCache: template.backgroundImage ? template.backgroundImage.large : null,
          originBackgroundCache: template.backgroundImage ? template.backgroundImage.large : null,
          cropperDataCache: null,
        }, [this.slideActive])
      } else {
        removeObjectFromIndexedDB(this.slideActive.id, 'background_images')
      }
      EventBus.$emit('eventHandleSetValueTransition')
      await this.callUpdateSlideApi({
        ...this.newSlide,
        backgroundImage: this.newSlide.backgroundImage && this.newSlide.backgroundImage.name,
      }, this.slideActive.id)
      this.backupSlide(this.oldSlide, this.newSlide)

      util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Content slide > Use template', `${template.id}`)
    },
  },
}
